module.exports = __webpack_public_path__ + "fonts/montserrat-medium-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Montserrat/montserrat-medium-webfont.woff
// module id = 3438
// module chunks = 0